import axios from "axios";
import React, { useEffect, useContext, useState } from "react";
import { Row, Col } from "react-grid-system";
import { Link } from "react-router-dom";
import styled from "styled-components";
import Button from "../components/Button";
import Card from "../components/Card";
import FlexBox from "../components/FlexBox";
import Icon from "../components/Icon";
import { UserContext } from "../context/UserContext";
import Status from "../types/enum/Status";

const SignOutCard = styled(Card)`
  text-align: center;
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(
    90deg,
    rgb(71, 85, 105) 0%,
    rgb(50 60 75) 118.29%
  );
`;

function SignOutPage() {
  const [isSignOutComplete, setSignoutComplete] = useState(false);
  const { isSignedIn, signOut } = useContext(UserContext);

  useEffect(() => {
    if (isSignedIn) {
      localStorage.removeItem("selectedVersion");
      localStorage.removeItem("selectedProgram");
      localStorage.removeItem("selectedProgramId");
      localStorage.removeItem("selectedSemester");

      axios
        .get("/logout")
        .then((res) => {
          signOut();
          setSignoutComplete(true);
        })
        .catch((err) => console.error(err));
    } else {
      setSignoutComplete(true);
    }
  }, [isSignedIn, signOut]);
  return (
    <>
      {isSignOutComplete && (
        <Row>
          <Col>
            <SignOutCard>
              <FlexBox
                direction="column"
                justify="center"
                style={{ height: "100%" }}
                space={3}
                alignItems="center"
              >
                {/* <img src={LogoImage} alt="" style={{ marginBottom: '24px' }} /> */}

                <h2>You are now signed out.</h2>
                <p>Thank you for using SIMON. Have a good day!</p>
                <p>
                  Need to get back in?{" "}
                  <Link style={{ color: "yellow" }} to="/signin">
                    Sign in again
                  </Link>
                  .
                </p>
              </FlexBox>
            </SignOutCard>
          </Col>
        </Row>
      )}

      {/* <Redirect to="/" /> */}
    </>
  );
}

export default SignOutPage;
